import Vue from 'vue'
import VueI18n from 'vue-i18n';
import {LANG_DEFAULT} from "@/config";

Vue.use(VueI18n)

function loadLocaleMessages() {
    const locales = require.context(
        "@/locales", // Путь к папке с нашими json файлами локализации
        true,
        /[A-Za-z0-9-_,.\s]+\.json$/i
    );
    const messages: any = {};
    locales.keys().forEach(key => {
        const matched = key.slice(2).split('.');
        if (matched && matched.length == 2) {
            const locale = matched[0];

            messages[locale] = Object.assign({}, messages[locale], locales(key));
        }

        if (matched && matched.length == 3) {
            const locale = matched[1];

            let ind: string = matched[0], ob: any = {};

            ob[ind] = locales(key);

            messages[locale] = Object.assign({}, messages[locale], ob);


        }


    });
    return messages;
}

function checkDefaultLanguage() { //Определяем язык браузера
    let matched = null;
    let languages = Object.getOwnPropertyNames(loadLocaleMessages());
    languages.forEach(lang => {
        if (lang === navigator.language) {
            matched = lang;
        }
    });
    if (!matched) {
        languages.forEach(lang => {
            let languagePartials = navigator.language.split("-")[0];
            if (lang === languagePartials) {
                matched = lang;
            }
        });
    }
    return matched;
}

export const selectedLocale = function () {
    if (localStorage.getItem('locale') && (localStorage.getItem('locale') === 'ru' || localStorage.getItem('locale') === 'en' || localStorage.getItem('locale') === 'de')) {
        return localStorage.getItem('locale') || LANG_DEFAULT
    } else {
        let navigator = window.navigator.language
        if (navigator.length > 2) navigator = navigator.slice(0, 2)
        if (navigator && ['ru', 'en', 'de'].includes(navigator)) {
            localStorage.setItem('locale', navigator)
            return navigator
        } else {
            localStorage.setItem('locale', 'en')
            return 'en'
        }
    }
}()


export const languages = Object.getOwnPropertyNames(loadLocaleMessages());
export default new VueI18n({
    locale: selectedLocale,
    fallbackLocale: "ru",
    messages: loadLocaleMessages()
});
